module.exports = __webpack_public_path__ + "static/media/learning.36e8c6ef.svg";